import { combineReducers } from 'redux';
import { getSuccessActionType } from '../utils';
import { getErrorReducer, getStatusReducer } from './utils/generators';
import { FETCH_SCORES } from '../constants/score';

function data(state = {}, action) {
  switch (action.type) {
    case getSuccessActionType(FETCH_SCORES):
      return action.payload;

    default:
      return state;
  }
}

export default combineReducers({
  status: getStatusReducer([FETCH_SCORES]),
  error: getErrorReducer([FETCH_SCORES]),
  data
});
